import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { cardinalApi, CardinalApiState, guard } from '../services/auth.api'
import { BingliImportParams, BingliImportResult, runBingliImport } from './bingliImport'

export type {
  AnswerOutcome,
  AnswerOutcomeKind,
  BingliImportDiagnostics,
  BingliImportParams,
  BingliImportResult,
  FormSummary,
  QuestionReference,
  RunBingliImportApis,
} from './bingliImport'
export { runBingliImport } from './bingliImport'

export const bingliApiRtk = createApi({
  reducerPath: 'bingliApi',
  tagTypes: ['Bingli'],
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    importBingliForms: builder.mutation<BingliImportResult | undefined, BingliImportParams>({
      async queryFn(params, { getState }) {
        const {
          cardinalApi: { user },
        } = getState() as { cardinalApi: CardinalApiState }
        const { contact: contactApi, form: formApi, healthcareParty: healthcarePartyApi, patient: patientApi } = (await cardinalApi(getState)) ?? {}
        return guard([contactApi, formApi, healthcarePartyApi, patientApi, user], ([contactApi, formApi, healthcarePartyApi, patientApi, user]) =>
          runBingliImport({ contact: contactApi, form: formApi, healthcareParty: healthcarePartyApi, patient: patientApi }, user, params),
        )
      },
      invalidatesTags: () => [],
    }),
  }),
})

export const { useImportBingliFormsMutation } = bingliApiRtk
